var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"sn-btn",class:_vm.btnType,attrs:{"disabled":_vm.disabled,"outline":_vm.outline,"block":_vm.block},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }